import type { UiKey } from "../i18n/ui";
import type { AudienceMode } from "../lib/audienceMode";

type Props = {
  t: (key: UiKey) => string;
  audienceMode: AudienceMode;
  /** Inside a parent card (e.g. collapsed “simple” flow) — no outer .card/.span-2. */
  embedded?: boolean;
};

export function AccuracyCallout({ t, audienceMode, embedded }: Props) {
  const bandKey =
    audienceMode === "simple" ? "accuracy.bandsSimple" : "accuracy.bandsTechnical";

  return (
    <section
      className={
        "accuracy-callout" + (embedded ? " accuracy-callout--embedded" : " card span-2")
      }
      aria-labelledby="accuracy-callout-title"
    >
      <h2 id="accuracy-callout-title">{t("accuracy.title")}</h2>
      <p className="accuracy-lead">{t("accuracy.lead")}</p>
      <ul className="accuracy-list">
        <li>{t("accuracy.pt1")}</li>
        <li>{t("accuracy.pt2")}</li>
        <li>{t("accuracy.pt3")}</li>
        <li>{t("accuracy.pt4")}</li>
      </ul>
      <p className="accuracy-bands">{t(bandKey)}</p>
      <style>{`
        .accuracy-callout {
          border-left: 3px solid var(--accent-dim);
          background: var(--surface2);
        }
        .accuracy-callout--embedded {
          background: transparent;
          border-left: none;
          padding: 0;
        }
        .accuracy-callout h2 {
          font-size: 1rem;
          margin: 0 0 0.5rem;
          color: var(--text);
        }
        .accuracy-lead {
          margin: 0 0 0.75rem;
          font-size: 0.88rem;
          line-height: 1.5;
          color: var(--text);
        }
        .accuracy-list {
          margin: 0 0 0.85rem;
          padding-left: 1.15rem;
          font-size: 0.82rem;
          line-height: 1.55;
          color: var(--muted);
        }
        .accuracy-list li {
          margin: 0.35rem 0;
        }
        .accuracy-bands {
          margin: 0;
          font-size: 0.8rem;
          line-height: 1.5;
          color: var(--accent);
          font-weight: 500;
          min-height: 4.8rem;
          min-height: 4lh;
        }
      `}</style>
    </section>
  );
}
